import some from 'lodash/some';
import every from 'lodash/every';
import sumBy from 'lodash/sumBy';
import reject from 'lodash/reject';

import { enum as payoutStatuses } from '../../../../../../../enums/payout-statuses';

export default function convertDataToRows(data) {
	return data.map((row) => {
		const payouts = row.payouts.map((payout) => ({
			...payout,
			amount_to_pay: getAmountWithPercent(payout.amount, payout.payout_percent, payout.payout_fee)
		}));

		const status = getPayoutRowStatus(row.payouts);
		const amount = getPayoutRowAmount(row.payouts);

		const payout_percent = payouts[0].payout_percent;
		const payout_fee = payouts[0].payout_fee;

		return {
			affiliate: row.affiliate,
			payouts,
			payload: {
				isInProcessing: some(payouts, 'isInProcessing'),
				is_urgent: some(payouts, 'is_urgent'),
				created_at: payouts[0].created_at,
				status,
				amount,
				payout_percent,
				payout_fee,
				amount_to_pay: getAmountWithPercent(amount, payout_percent, payout_fee),
				paid_at: getPayoutRowPaidAt(payouts, status)
			}
		};
	});
}

// important: payout row status depends on grouping logic
function getPayoutRowStatus(payouts) {
	// order of statuses is important here
	for (const status of [payoutStatuses.pending, payoutStatuses.approved, payoutStatuses.confirmed]) {
		if (some(payouts, { status })) return status;
	}

	for (const status of [payoutStatuses.paid, payoutStatuses.rejected]) {
		if (every(payouts, { status })) return status;
	}
}

function getPayoutRowAmount(payouts) {
	return sumBy(reject(payouts, { status: payoutStatuses.confirmed }), 'amount');
}

function getPayoutRowPaidAt(payouts, status) {
	if (status === payoutStatuses.paid && payouts[payouts.length - 1].paid_at) {
		return payouts[payouts.length - 1].paid_at;
	}
	return status !== payoutStatuses.paid ? null : payouts[payouts.length - 1].updated_at;
}

function getAmountWithPercent(amount, payout_percent, payout_fee) {
	return Number((amount * (1 + +payout_percent / 100) + Number(payout_fee)).toFixed(2));
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/list/helpers/convert-data-to-rows.js